import React from 'react'
import S3_home_1 from '../../img/S3_home_1.jpg'
import S3_home_2 from '../../img/S3_home_2.jpg'
import S3_home_3 from '../../img/S3_home_3.jpg'
import {Link} from 'react-router-dom'





const S2_home = () => {
    return (
<section className='S3_home'>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-4 col-md-6'>
                       
            <div className='card'>     
                <img src={S3_home_1} alt='sora'/>          
            <div className='card_body'>
                <h3>20% Off On Tank Tops</h3>      
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac dictum.</p>
                <Link to="/Store">SHOP NOW</Link>                           
            </div>
            </div>  
            </div>     
                    
            <div className='col-lg-4 col-md-6'>
            <div className='card'>
                <img src={S3_home_2} alt='sora'/>  
            <div className='card_body'>
                <h3>20% Off On Tank Tops</h3>      
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac dictum.</p>
                <Link to="/Store">SHOP NOW</Link>                           
            </div>               
            </div>                      
            </div>
                    
            <div className='col-lg-4 col-md-6'>
            <div className='card'>
                <img src={S3_home_3} alt='sora'/>  
            <div className='card_body'>
                <h3>20% Off On Tank Tops</h3>      
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac dictum.</p>
                <Link to="/Checkout">CHECK OUT</Link>                           
            </div>            
            </div>                  
             </div>        

        
        </div>  
    </div>        
</section>

      
      

  )
}

export default S2_home